import moment from 'moment'
import * as _ from 'lodash'
class LineChartService {
  extractLineChartData(data, keyToSum, startDate, endDate) {
    const intervals = this._generateChartIntervals(startDate, endDate)
    const groupedData = this._groupByDateInterval(data, intervals)
    return {
      labels: Object.keys(groupedData),
      datasets: [
        {
          data: Object.keys(groupedData).map(
            key =>
              !keyToSum ? groupedData[key].length : _.sumBy(groupedData[key], element => parseFloat(element[keyToSum]))
          ),
          fill: false,
          radius: 6,
          hoverRadius: 8,
          borderWidth: 3,
          hoverBorderWidth: 4,
          backgroundColor: '#3bb2b8',
          borderColor: '#fff'
        }
      ]
    }
  }

  _groupByDateInterval(data, intervals) {
    return {
      ...intervals.formattedValues.reduce((acc, interval) => {
        acc[interval] = []
        return acc
      }, {}),
      ..._.groupBy(data, function(element) {
        for (let index = 1; index < intervals.formattedValues.length; index++) {
          const isInThisInterval = moment(element.date).isBetween(
            moment(intervals.values[index - 1]),
            moment(intervals.values[index]),
            null,
            '[]'
          )
          if (isInThisInterval) return intervals.formattedValues[index]
        }
      })
    }
  }

  _generateChartIntervals(initDate, finalDate) {
    var timeSpan = moment(finalDate).unix() * 1000 - moment(initDate).unix() * 1000
    var interval = timeSpan / 7
    var intervals = { formattedValues: [], values: [] }
    var daysInterval = moment(finalDate).diff(initDate, 'days')
    var formatDateLabel = ''
    if (daysInterval < 2) {
      formatDateLabel = 'dd HH[h]'
    } else if (daysInterval < 8) {
      formatDateLabel = 'dd Do'
    } else if (daysInterval < 32) {
      formatDateLabel = 'MMM DD'
    } else {
      formatDateLabel = "MMM DD 'YY"
    }
    daysInterval = daysInterval === 0 ? 1 : daysInterval
    for (var i = 0; i <= 7; i++) {
      var stepDate = moment(initDate).unix() * 1000 + interval * i
      intervals.formattedValues.push(moment(stepDate).format(formatDateLabel))
      intervals.values.push(moment(stepDate))
    }

    return intervals
  }
}

export default new LineChartService()



// WEBPACK FOOTER //
// ./src/services/LineChartService.js